<template>
  <span class="text-sm font-medium text-gray-700">
    <slot />
  </span>
</template>

<script lang="ts">
import { defineComponent } from 'vue'



export default defineComponent({
  name: 'UITextLabel',
})
</script>

<style scoped>

</style>
